// extracted by mini-css-extract-plugin
export default {"container":"DYn9gcIR8wMeT6PzCBfr"};